import React from "react";
import "./App.scss";
import { HashRouter as Router } from "react-router-dom";
import Main from "./pages/Main";

function App() {
  return (
    <Router>
      <Main />
    </Router>
  );
}
export default App;
